export const content = {
	altLogo: `Med AI`
}